// @flow
import React from "react";
import "./styles.css";
import uuid from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

const type = "image";
const excludedProps = ["children", "className", "labelText"];
const filterProps = _props => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {}),
    type,
    id: _props.id || uuid()
});


type PropsType = {
    disabled: boolean,
    label: string,
    download: string | boolean,
    icon: string,
    href?: string,
    target?: string,
    onClick?: any => any,
    containerProperties?: Object,
    className?: string,
    style?: Object
};

export const IconButton = (
    {
        disabled = false,
        label = "",
        icon = "",
        href,
        download = false,
        onClick,
        target,
        containerProperties = {},
        className
    }: PropsType
) => {


    const innards = Boolean(icon) ? (
        <span className={ "icon-button--icon" }>
            <FontAwesomeIcon icon={ icons[icon] }/>
        </span>
    ) : null;

    return (
        <div className={ classNames("icon-button", className) }>
            { (Boolean(href))
                ? (
                    <a
                        { ...filterProps(containerProperties) }
                        download={ download }
                        target={ target }
                        className={ classNames("icon-button--button", { "is-disabled": disabled }) }
                        href={ disabled ? "#" : href }
                    >
                        { innards }
                    </a>
                )
                : (
                    <button
                        { ...filterProps(containerProperties) }
                        disabled={ disabled }
                        className={ classNames("icon-button--button", { "is-disabled": disabled }) }
                        onClick={ onClick }
                    >
                        { innards }
                    </button>
                )
            }
            { Boolean(label) && (<span className="icon-button--label-text">{ label }</span>) }
        </div>);
};


